/*
 * @Author: Jhony Reyes 
 * @Date: 2018-08-12 23:46:03 
 * @Last Modified by: Jhony Reyes
 * @Last Modified time: 2018-12-26 16:21:24
 */
const CONTAINER_KEY = 'ORDERS_CONTAINER';
export const FETCH_ORDERS = `${CONTAINER_KEY}_FETCH_ORDERS`;
export const FETCH_ORDERS_FULFILLED = `${FETCH_ORDERS}_FULFILLED`;
